import React from "react";
import { IconProps } from "../type";

export function Phone({
  size = 24,
  color = "currentColor",
  className = "",
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.581 24.0063C15.901 23.9445 11.1398 23.2865 6.15345 18.3013C1.16828 13.315 0.51145 8.55496 0.44845 6.87379C0.355117 4.31179 2.31745 1.82329 4.58428 0.851456C4.85726 0.733584 5.15619 0.688706 5.45174 0.721227C5.74729 0.753748 6.0293 0.862549 6.27012 1.03696C8.13678 2.39729 9.42478 4.45529 10.5308 6.07346C10.7741 6.42897 10.8782 6.86159 10.8231 7.28888C10.768 7.71618 10.5577 8.10827 10.2321 8.39046L7.95595 10.081C7.84598 10.1604 7.76858 10.277 7.73811 10.4092C7.70764 10.5413 7.72618 10.6801 7.79028 10.7996C8.30595 11.7365 9.22295 13.1318 10.273 14.1818C11.323 15.2318 12.7848 16.2095 13.787 16.7835C13.9126 16.854 14.0605 16.8737 14.2002 16.8386C14.34 16.8034 14.461 16.716 14.5383 16.5945L16.0199 14.3393C16.2924 13.9774 16.6942 13.735 17.1413 13.6628C17.5884 13.5906 18.0462 13.6942 18.4186 13.952C20.0601 15.0883 21.9758 16.3541 23.3781 18.1496C23.5667 18.3922 23.6866 18.6809 23.7254 18.9857C23.7642 19.2905 23.7204 19.6001 23.5986 19.8821C22.6221 22.1606 20.1511 24.1008 17.581 24.0063Z"
        fill={color}
      />
    </svg>
  );
}
